<template>
	<li class="">
		<slot name="default" v-if="!$slots['sub-menu']">
			<!-- Fallback content is rendered here -->
		</slot>

		<button
			class="c-site-menu__primary-link c-site-menu__trigger h-text--h2-display"
			type="button"
			@click.prevent="() => toggle()"
			:aria-expanded="isOpen"
			:aria-controls="id"
			v-if="$slots.trigger"
		>
			<slot name="trigger"></slot>
		</button>

		<div
			:class="{ 'c-site-menu__sub-menu': true, 'is-open': this.isOpen }"
			:id="id"
			v-if="$slots['sub-menu']"
		>
			<button class="c-site-menu__back" @click.prevent="() => toggle(false)">
				<span class="icon">
					<arrowLeft />
				</span>
				Back
			</button>

			<ul class="c-site-menu__sub-menu-items">
				<li class="c-site-menu__overview">
					<a class="h-text--h2-display" :href="url">{{ label }}</a>
				</li>
				<slot name="sub-menu"></slot>
			</ul>
		</div>
	</li>
</template>

<script>
	import arrowLeft from "/web/static/images/svgs/icon-arrow-left.svg?component";

	export default {
		name: "site-menu-item",

		data() {
			return {
				isOpen: false,
			};
		},

		components: {
			arrowLeft,
		},

		props: {
			id: {
				type: String,
			},
			label: {
				type: String,
			},
			url: {
				type: String,
			},
		},

		methods: {
			toggle(open = !this.isOpen) {
				this.isOpen = open;
				document.documentElement.classList.toggle(
					"has-open-sub-menu",
					this.isOpen,
				);
			},
		},
	};
</script>
